export enum ErrorCode {
    VALIDATION_PASSED = 0,
    ERROR_MISSING_FIELDS = 1,
    ERROR_NEGATIVE_COST = 2,
    ERROR_NEGATIVE_SMU = 3,
    ERROR_SMU=4,
}

export class ErrorMessages {
    public static readonly ERROR_SAVING = "There was an error saving this change. ";
    public static readonly ERROR_Exist = "Workshop already exist with same name. ";
    public static readonly ERROR_MISSING_FIELDS = "Please enter all required fields to continue.";
    public static readonly ERROR_NEGATIVE_COST = "Please enter a non-negative value for the cost.";
    public static readonly ERROR_NEGATIVE_SMU = "Please enter a non-negative value for the smu.";
    public static readonly ERROR_SMU = "Invalid SMU";
}